import M_LX_REPORT from "@fql/lx_report"

// 实例初始化
const M_REPORT = new M_LX_REPORT({
    mainSwitch: true,
    reportSwitch: true
})

const EVENT_POS_CODE = 'PLC_WEB.RULE.LX_RULE_LIST.'
const EVENT_TYPE = 2

/**
 * 数据上报
 * @param  {Object} reportOptions 上报配置
 * @param  {String} reportOptions.eventPosName 事件ID说明
 * @param  {String} reportOptions.hottag 点击流
 * @param  {String} reportOptions.event_type 行为类型
 * @param  {Object} reportOptions.reportExtendInfo 扩展信息
 */
export const dataReport = (reportOptions = {}, reportExtendInfo = {}) => {
    const event_pos = EVENT_POS_CODE + (reportOptions.hottag || '')
    try {
        M_REPORT.pageReport({
            record_type: EVENT_TYPE,
            event_pos,
            event_pos_name: reportOptions.eventPosName,
            event_type: reportOptions.event_type || EVENT_TYPE,
            extend_info: {},
            standard_extend_info: reportExtendInfo,
            event_case_code: event_pos
        })
    } catch (error) {
        console.error(error);
    }
};